export const suiteIdentifiers = {
  DEALER_PORTAL: 'dealerPortal-bb31c873-230a-4d3f-820c-cab32d3983e7',
};
